import React from 'react';
import Layout from '@common/layout';
import Head from 'next/head';
import Project from '@components/projects/project';
import { PROJECTS } from '@config/projects';

const ProjectsPage = () => (
    <React.Fragment>
        <Head>
            <title>Realm | Resort Suites at Sheraton</title>
        </Head>
        <div className="bg-realm-dark pt-32 md:pt-40 min-h-screen">
            <Project {...PROJECTS[9]} projectNumber={'10'} nextLink={PROJECTS[10].link} />
        </div>
    </React.Fragment>
);

export default Layout(ProjectsPage, { headerMode: 'fixed', footerColor: 'bg-tan' });
